export const POSITIONS = ['GK', 'CB', 'LB', 'RB', 'CDM', 'CM', 'RM', 'LM', 'LW', 'RW', 'ST'];

export const POSITION_LABELS = {
  GK: 'Goalkeeper',
  CB: 'Centre back',
  LB: 'Left back',
  RB: 'Right back',
  CDM: 'Defensive mid',
  CM: 'Centre mid',
  RM: 'Right mid',
  LM: 'Left mid',
  LW: 'Left wing',
  RW: 'Right wing',
  ST: 'Striker',
};

export const ATTRS = [
  { key: 'pace', label: 'Pace' },
  { key: 'shooting', label: 'Shooting' },
  { key: 'passing', label: 'Passing' },
  { key: 'technique', label: 'Technique' },
  { key: 'defending', label: 'Defending' },
  { key: 'physical', label: 'Physical' },
  { key: 'stamina', label: 'Stamina' },
];

/**
 * Only shown, and only stored, for players who list GK. It is deliberately NOT
 * part of ATTRS: everyone else is rated on the same seven, so overalls stay
 * comparable.
 */
export const GK_ATTR = { key: 'goalkeeping', label: 'Goalkeeping' };

/** The attributes to show for a player, given the positions they've picked. */
export function attrsFor(positions) {
  return (positions || []).includes('GK') ? [...ATTRS, GK_ATTR] : ATTRS;
}

export const DEFAULT_ATTRS = {
  pace: 5,
  shooting: 5,
  passing: 5,
  technique: 5,
  defending: 5,
  physical: 5,
  stamina: 5,
};

/**
 * Players are rated out of ten, the way match reports have always done it.
 *
 * This replaced five emoji faces. The faces had two problems: nobody agreed on
 * what the middle two meant — is 🙂 a good game or a shrug? — and five steps is
 * too coarse to separate "quietly did his job" from "was actually poor", which
 * is most of the games most people play. A number carries its own scale. Nobody
 * needs a legend for 7 out of 10.
 */
export const RATING_MIN = 1;
export const RATING_MAX = 10;

/** The exact midpoint. A player on this number moves nobody's form either way. */
export const RATING_NEUTRAL = 5.5;

export const RATING_STEPS = Array.from(
  { length: RATING_MAX - RATING_MIN + 1 },
  (_, i) => RATING_MIN + i
);

/**
 * A word for a number, shown beside whatever you picked so the scale anchors
 * itself. Deliberately football-report language rather than praise: on this
 * scale a 6 is a perfectly respectable game, not a disappointment.
 */
export function ratingWord(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return '';
  if (n <= 2) return 'Shocker';
  if (n <= 4) return 'Poor';
  if (n < 6) return 'Quiet';
  if (n < 7) return 'Steady';
  if (n < 8) return 'Good';
  if (n < 9) return 'Excellent';
  return 'Unplayable';
}
